export const DEFAULT_LOCALHOST_TENANT = "demo";

export const getTenant = () => {
  if (
    process.env.NODE_ENV === "production" &&
    !window.location.origin.includes(
      "-dot-okf-fe-dev-dot-ok-framework.el.r.appspot.com"
    )
  ) {
    // Injected by SSR handler via __TENANT_INJECTION__ in index.html
    return window.__TENANT__;
  } else {
    //localhost
    return localStorage.getItem("localhost_tenantId") || DEFAULT_LOCALHOST_TENANT;
  }
};
